import { Component, Inject, OnInit } from "@angular/core";
import {
  FormControl,
  Validators,
  FormGroup,
  FormArray,
  FormBuilder,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { UlbProposalService } from "adminModules/ulb-proposals/ulb-proposal.service";
import { exit } from "process";
import {
  debounceTime,
  distinctUntilChanged,
  startWith,
  take,
} from "rxjs/operators";
import { CityService, UtilityService } from "services";
import { PATTERN } from "utils/constants";

@Component({
  selector: "app-confirmation-dialogs",
  templateUrl: "./confirmation-dialogs.component.html",
  styles: [
    "p{text-align: justify}",
    ".content-wrap{max-height:60vh;overflow-y:auto;margin-bottom:2rem}",
  ],
})
export class ConfirmationDialogsComponent implements OnInit {
  acknowledged = new FormControl(false);
  item: string;
  file;
  error;
  remark = new FormControl(null, Validators.required);
  group: any;
  ListOfCluserULBId = [];
  percentageValue: number = 100;
  count: number = 0;
  isPercentage0: boolean = false;
  isReadOnly: boolean = true;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ConfirmationDialogsComponent>,
    private fb: FormBuilder,
    private city: CityService,
    public service: UlbProposalService,
    private util: UtilityService,
    private route: ActivatedRoute,
    private router: Router
  ) {}
  ngOnInit() {
    this.createForm();
    this.item = this.data.item ? this.data.item : "";
    this.data.body = this.data.body.replace("%%TMP%%", this.data.url);

    this.otherUlbArray.controls.map((item, index) => {
      item.get("percentage").setValue(this.percentageValue);
      item.get("distance").setValue(0);
      item.get("ulb").setValue(this.util.getUlbName());
      item.get("ulbId").setValue(this.util.getUlbCode());
      // item.get("percentage").
    });
  }

  createForm() {
    this.group = this.fb.group({
      stateId: new FormControl(null),
      districtId: new FormControl(null),
      ulbId: new FormControl(null),
      stateName: new FormControl(),
      districtName: new FormControl(),
      ulbName: new FormControl(),
      isLandFillShared: new FormControl(),
      otherULBs: this.fb.array([this.initOtherUlb()]),
    });
  }
  initOtherUlb() {
    return this.fb.group({
      ulbId: new FormControl(null, Validators.required),
      percentage: new FormControl(0),
      distance: new FormControl(0),
      ulb: new FormControl(null, Validators.required),
    });
  }
  get otherUlbArray() {
    return this.group.get("otherULBs") as FormArray;
  }
  updateValue(index, value) {}

  indexedValues = [];
  obj = {};
  previousValue: number = 0;
  currentValue: number = 0;
  currentCount: any;
  totalValue: number = 0;
  zeroIndexValue: number;
  sum = 0;
  errorMessage = "";
  totalPercentage = 100;
  evalutePercentage() {
    this.otherUlbArray.controls.map((item, index) => {
      item
        .get("percentage")
        .valueChanges.pipe(debounceTime(500), distinctUntilChanged())
        .subscribe((val) => {
          this.zeroIndexValue =
            this.otherUlbArray.controls[0].get("percentage").value;
          this.currentValue = val;
          if (!item.get("percentage").value) {
            item.get("percentage").setValue(0);
          }
          if (index > 0) {
            let array = this.otherUlbArray.controls.map((item, index) =>
              index != 0 ? item.get("percentage").value : 0
            );
            let sumofArray = array.reduce((a, b) => {
              return parseFloat(a) + parseFloat(b);
            });
            if (sumofArray > 100) {
              this.util.showMsg(
                "Sum of capacity to be allocated can not be more than 100 percentage"
              );
            } else {
              let result = 100 - sumofArray;
              this.otherUlbArray.controls[0]
                .get("percentage")
                .setValue(result, { emitEvent: false });
            }
          }
        });
    });
  }

  inputChange($event, itemIndex) {
    debugger;
    console.log("hghj", $event);
    console.log("demo", itemIndex);
  }

  addUlb() {
    this.otherUlbArray.push(this.initOtherUlb());
    this.evalutePercentage();
  }

  ulbValue(itemIndex, $event) {}
  removeUlbb(index) {
    this.util
      .confirm("Remove", `Are you sure want to remove this ULB?`)
      .pipe(take(1))
      .subscribe((confirmed) => {
        if (confirmed) {
          const id = this.otherUlbArray.controls[index].get("id").value;
          if (id) {
            this.city.delete("swminfrastructure/ulb/", id).subscribe(
              (res) => {},
              (err) => {
                this.util.errorMessage(err);
              }
            );
          }
          return this.otherUlbArray.removeAt(index);
        }
      });
  }
  removeUlb(index, control) {
    debugger;
    this.util
      .confirm("Remove ULB", `Are you sure want to remove this ULB?`)
      .pipe(take(1))
      .subscribe((confirmed) => {
        if (confirmed) {
          let firstIndexValue =
            this.otherUlbArray.controls[0].get("percentage").value;
          let removeValue = control.get("percentage").value;
          let result = parseInt(firstIndexValue) + parseInt(removeValue);
          this.otherUlbArray.controls[0]
            .get("percentage")
            .setValue(result, { emitEvent: false });
          return this.otherUlbArray.removeAt(index);
        }
        // }
      });
  }

  confirm() {
    if (this.group.valid) {
      if (this.data.isBulkUpload) {
        this.error = null;
        if (this.file) {
          return this.uploadFile();
        }
        return (this.error = true);
      } else if (this.data.isReject) {
        if (this.remark.valid) {
          this.dialogRef.close({ remark: this.remark.value });
        } else {
          this.remark.markAsTouched();
        }
      } else if (
        this.acknowledged.value &&
        this.otherUlbArray.value.length <= 1
      ) {
        this.util.showMsg("Please select minimum two ULB");
      } else {
        console.log("this.otherUlbArray :::", this.otherUlbArray.value);
        try {
          this.otherUlbArray.value.forEach((e1) => {
            if (e1.percentage === 0 || e1.percentage === "0") {
              console.log("Other Ulb percentage ::::", e1.percentage === 0);
              this.isPercentage0 = false;
              this.util.showMsg("Percentage to be allocated can not be 0 ");
              throw new Error("Percentage to be allocated can not be 0");
            } else {
              this.isPercentage0 = true;
            }
          });
        } catch (error) {
          console.log("Exception thrown from the forEach loop." + error);
        }
        if (this.isPercentage0 == true) {
          this.otherUlbArray.controls.map((item, index) => {
            const ulbidid =
              this.otherUlbArray.controls[index].get("ulbId").value;
            this.ListOfCluserULBId.push(ulbidid);
          });
          this.dialogRef.close({
            id: this.data.id,
            checkboxValue: this.acknowledged.value,
            clusterdata: this.otherUlbArray.value,
          });
        }
      }
    } else {
      this.util.setAsTouched(this.group);
      console.log(this.util.findInvalidControls(this.group));
      this.util.scrollToError();
    }
  }
  getHierarchy() {
    const { applicationName, moduleName, subModuleName } = this.data;
    const level = [applicationName, moduleName, subModuleName];
    return level?.length ? level.filter((i) => i) : [];
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
    } else {
      this.file = null;
    }
  }

  uploadFile() {
    if (this.file) {
      this.dialogRef.close(this.file);
    }
  }
  CheckValidation(event) {
    //console.log(event)
  }
}
